import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import moment from 'moment-timezone';
import SearchResultsTicket from '../SearchResultsTicket/SearchResultsTicket';
import { SetComponentLanguage, ApiRequest } from '../../../../helpers';
import { DymoPrint } from '../../../../lib/labels/DYMO.print';
import PrinterOptions from '../../../Common/PrinterOptions/PrinterOptions';
import Boca from '../../../../lib/labels/boca';
import Star from '../../../../lib/labels/star';
import Message from '../../../Common/Message/Message';
import AlertModal from '../../../Common/AlertModal/AlertModal';
import AlertModalBoca from '../../../Common/AlertModalBoca/AlertModalBoca';
import AlertModalStar from '../../../Common/AlertModalStar/AlertModalStar';
import printIcon from '../../../../images/icons/print.svg';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './SearchResultsTransaction.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SearchResultsTransaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: {
                title: '',
                content: '',
                type: ''
            },
            isModalOpen: false,
            isModalOpenBoca: false,
            isModalOpenStar: false,
        }
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    reemail = (e) => {
        this.setMessage('', '', 'loading');
        const doReEmail = async () => {
            try {
                const emailResponse = await email(e.target.id);
                if(emailResponse.data.success){
                    this.setMessage(window.general_strings.msg.yay, strings.msg.emailSuccess, 'success');
                    setTimeout(() => {
                        this.setMessage('', '', '');
                    }, 3000);
                }
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        }

        async function email(data) {
            return await ApiRequest(`/transactions/${data}/resend-email`, {
                method: "POST"
            });
        }

        doReEmail();
    }

    distribute = (e) => {
        this.setMessage('', '', 'loading');
        const doDistribute = async () => {
            try {
                const tokenResponse = await getToken(e.target.id);
                console.log('tokenResponse', tokenResponse)
                if(tokenResponse.data.token){
                    window.open(`/customer-tickets?token=${tokenResponse.data.token}`);
                    setTimeout(() => {
                        this.setMessage('', '', '');
                    }, 3000);
                }
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        }

        async function getToken(transaction_id) {
            return await ApiRequest(`/generate-customer-tickets-token`, {
                method: "POST",
                data: {
                    transaction_id,
                }
            });
        }

        doDistribute();
    }

    reprintPDF = (e) => {
        console.log(e.target.id);
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/transactions/${e.target.id}/print`);
    }

    dymoPDF = (e) => {
        console.log(e.target.id);
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/transactions/${e.target.id}/print-dymo`);
    }

    toggleAlertModal = (e) => {
        e.preventDefault();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
    }

    confirmAlertModal = () => {
        this.setState({
            isModalOpen: false
        }, () => this.printTransactionDymoTickets());
    }

    printTransactionDymoTickets = async () => {
        console.log('here');
        try {
            const getTicketInfoFromTransaction = await getTicketInfo(this.props.transaction.id);
            console.log('Get ticket info from transaction: ', getTicketInfoFromTransaction);

            if (!getTicketInfoFromTransaction.data.error) {
                const { tickets, client, customer } = getTicketInfoFromTransaction.data;
                DymoPrint(this.props.currentPrinter, 'ticket', tickets, client, customer);

                getTicketInfoFromTransaction.data.flexpasses.map(async (flexpass) => {
                    await DymoPrint(this.props.currentPrinter, 'flexpass', flexpass, client, customer);
                });
            } else {
                this.setMessage(window.general_strings.msg.oops, getTicketInfoFromTransaction.data.error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }

        async function getTicketInfo(transaction) {
            return await ApiRequest(`/transactions/${transaction}/ticket-info`);
        }
    }

    printerSelect = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.props.printers.length > 0 ?
                        <select className="showtix-input"
                            value={this.props.currentPrinter}
                            onChange={this.props.handlePrinterChange}>
                            <PrinterOptions printers={this.props.printers} />
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    }

    toggleAlertModalBoca = (e) => {
        e.preventDefault();
        if (this.props.currentPrinterBoca === '') {
            this.setState({
                isModalOpenBoca: !this.state.isModalOpenBoca,
            });
        } else {
            this.printTransactionBocaTickets();
        }
    }

    confirmAlertModalBoca = () => {
        if(!localStorage.getItem("defaultBocaPrinter")) {
            localStorage.setItem('defaultBocaPrinter', localStorage.getItem("printersBoca")[0]);
            this.setState({
                currentPrinterBoca: localStorage.getItem("printersBoca")[0]
            });
        }
        this.setState({
            isModalOpenBoca: false
        }, () => this.printTransactionBocaTickets());
    }

    printTransactionBocaTickets = async () => {
        console.log('printTransactionBocaTickets', this.props.printersBoca);
        console.log('currentPrinterBoca', this.props.currentPrinterBoca);

        try {
            const getTicketInfoFromTransaction = await getTicketInfo(this.props.transaction.id);
            console.log('Get ticket info from transaction: ', getTicketInfoFromTransaction);
            const client = getTicketInfoFromTransaction.data.client;
            const customer = getTicketInfoFromTransaction.data.customer;
            if (!getTicketInfoFromTransaction.data.error) {
                const tickets = getTicketInfoFromTransaction.data.tickets;
                const flexpasses = getTicketInfoFromTransaction.data.flexpasses;
                if(tickets || flexpasses) {
                    let boca = new Boca();
                    if(tickets) {
                        boca.printFGL(this.props.currentPrinterBoca, 'ticket', tickets, client, customer);
                    }
                    if(flexpasses) {
                        boca.printFGL(this.props.currentPrinterBoca, 'flexpass', flexpasses, client, customer);
                    }
                }
            } else {
                this.setMessage(window.general_strings.msg.oops, getTicketInfoFromTransaction.data.error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }

        async function getTicketInfo(transaction) {
            return await ApiRequest(`/transactions/${transaction}/ticket-info`);
        }
    };

    printerSelectBoca = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.props.printersBoca.length > 0 ?
                        <select className="showtix-input"
                                value={this.props.currentPrinterBoca}
                                onChange={this.props.handlePrinterChangeBoca}>
                            <option>Select</option>
                            {this.props.printersBoca.map((printer, i) => (
                                <option value={this.props.printersBoca[i].name}>{this.props.printersBoca[i].name}</option>
                            ))}
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    };

    printerSelectStar = () => {
        return (
            <React.Fragment>
                <div className="showtix-form__group">
                    <div className="showtix-form__select">
                        {this.props.printersStar.length > 0 ? (
                                <select className="showtix-input"
                                    value={this.props.currentPrinterStar}
                                    onChange={this.props.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    {this.props.printersStar.map((printer, i) => (
                                        <option value={this.props.printersStar[i].ip_address}>{this.props.printersStar[i].name} ({this.props.printersStar[i].ip_address})</option>
                                    ))}
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            ) : (
                                <select className="showtix-input"
                                    value={this.props.currentPrinterStar}
                                    onChange={this.props.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            )
                        }
                    </div>
                </div>
                {this.props.printersStarUSB.length > 0 && (
                    <React.Fragment>
                        USB Printers:
                        <div className="showtix-form__group">
                            <div className="showtix-form__select">
                                {this.props.printersStarUSB.length > 0 && (
                                    <select className="showtix-input"
                                        value={this.props.currentPrinterStar}
                                        onChange={this.props.handlePrinterChangeStar}
                                    >
                                        <option>Select</option>
                                        {this.props.printersStarUSB.map((printer, i) => (
                                            <option value={this.props.printersStarUSB[i].name}>{this.props.printersStarUSB[i].name}</option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    };

    toggleAlertModalStar = (e) => {
        e.preventDefault();
        if (this.props.currentPrinterStar === '') {
            console.log('toggleAlertModalStar');
            this.setState({
                isModalOpenStar: !this.state.isModalOpenStar,
            });
        } else {
            console.log('printTransactionStarTickets');
            this.printTransactionStarTickets();
        }
    }

    confirmAlertModalStar = () => {
        if(!localStorage.getItem("defaultStarPrinter")) {
            localStorage.setItem('defaultStarPrinter', localStorage.getItem("printersStar")[0]);
            this.setState({
                currentPrinterStar: localStorage.getItem("printersStar")[0]
            });
        }
        this.setState({
            isModalOpenStar: false
        }, () => this.printTransactionStarTickets());
    }

    printTransactionStarTickets = async () => {
        try {
            const getTicketInfoFromTransaction = await getTicketInfo(this.props.transaction.id);
            console.log('Get ticket info from transaction: ', getTicketInfoFromTransaction);
            const client = getTicketInfoFromTransaction.data.client;
            const customer = getTicketInfoFromTransaction.data.customer;
            if (!getTicketInfoFromTransaction.data.error) {
                const tickets = getTicketInfoFromTransaction.data.tickets;
                const flexpasses = getTicketInfoFromTransaction.data.flexpasses;
                let star = new Star();
                let isStarUSB = !localStorage.getItem('defaultStarPrinter').includes('http');
                if(tickets || flexpasses) {
                    if(tickets) {
                        if (isStarUSB) {
                            star.printFGLUSB(localStorage.getItem('defaultStarPrinter'), 'ticket', tickets, client, customer);
                        } else {
                            star.printFGL('ticket', tickets, client, customer);
                        }
                    }
                    if(flexpasses) {
                        if (isStarUSB) {
                            star.printFGLUSB(localStorage.getItem('defaultStarPrinter'), 'flexpass', flexpasses, client, customer);
                        } else {
                            star.printFGL('flexpass', flexpasses, client, customer);
                        }
                    }
                }
            } else {
                this.setMessage(window.general_strings.msg.oops, getTicketInfoFromTransaction.data.error, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }

        async function getTicketInfo(transaction) {
            return await ApiRequest(`/transactions/${transaction}/ticket-info`);
        }
    };

    transactionTickets(param) {
        return (
            (param.transaction.tickets.map((ticket, i) => 
                [
                    (ticket.visible &&
                        <SearchResultsTicket 
                            key={i} 
                            events={this.props.events}
                            ticket={ticket}
                            archived={this.props.archived}
                            toggleAlertModal={this.props.toggleAlertModal}
                            toggleReleaseRefundModal={this.props.toggleReleaseRefundModal}
                            updateSelectedIds={this.props.updateSelectedIds}
                            setMessage={this.props.setMessage}
                            transaction={param.transaction}
                            eventsResults={this.props.eventsResults}
                            user={this.props.user}
                            isGodMode={this.props.isGodMode}
                        />
                    )    
                ]
                
            ))
        )
    }

    transactionFlexpasses(param) {
        return (
            <div className="showtix-search__transaction__tickets showtix-search__transaction__flexpasses">
                <h3 className="showtix-search__transaction__tickets__title">{strings.flexpasses}</h3>
                {param.transaction.flexpasses.map((flexpass) => (
                    <div className="showtix-search__transaction__ticket">
                        <div className="showtix-search__transaction__title">
                            <div className="showtix-search__transaction__title__item">
                                {flexpass.flexpass_name} - {flexpass.tickets_used} of {flexpass.max_tickets} ticket(s) used
                            </div>
                            {(flexpass.status !== 'active') &&
                                <div className="showtix-search__transaction__title__item">
                                    <span>Status:</span>
                                    <span className="showtix-badge showtix-background__primary-1">{flexpass.status}</span>
                                </div>
                            }
                            <div className="showtix-search__transaction__title__item">
                                <span>{strings.code}</span> {flexpass.code}
                            </div>
                            <div className="showtix-search__transaction__title__item">
                                <span>{strings.price}</span> {new Intl.NumberFormat('en-US', { 
                                        style: 'currency', 
                                        currency: 'USD' 
                                    }).format(flexpass.price)}
                            </div>
                        </div>
                        {this.transactionFlexpassesButton(param, flexpass)}
                    </div>     
                ))}
            </div>
        );
    }

    transactionFlexpassesButton(param, flexpass) {
        if (param.transaction.status !== 'released'){
            if (param.transaction.status !== 'refunded') {
                if (param.transaction.tender_type === 'credit-card') {
                    return (
                        <div className="showtix-search__transaction__buttons">
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                onClick={this.props.toggleReleaseRefundModal}
                                id={flexpass.id}
                                title={strings.releaseTitle}
                                description={strings.releaseDescription}
                                transaction_id={flexpass.transaction_id}
                                action="release-refund"
                                type="flexpass"
                            >
                                {strings.releaseRefund}
                            </button>
                        </div>
                    )
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    transactionMail(param) {
        let string = "";
        switch(param.shipping_method){
            case "mail":
            if(param.date_mailed !== "0000-00-00"){
                string += "Mailed: " + moment.utc(param.date_mailed).format('LLLL');
            } else {
                string += "Mail";
            }
            break;

            case "print":
            string += "Email";
            break;

            case "will-call":
            string += "Will Call";
            break;

            default:
            string += "-";
            break;
        }
        return string;
    }

    transactionButtons(param) {
        param.event_ids = [...new Set(param.tickets.map((ticket) => ticket.event_id))];
        let eventPayedOut = false;
        param.event_ids.forEach((event_id) => {
            this.props.eventsResults.forEach((event) => {
                if (event_id === event.id) {
                    if (event.payout_created) {
                        eventPayedOut = true;
                    }
                }
            });
        });
        
        // Is Call Center
        if(this.props.user.role === 'admin' || this.props.isGodMode){
            if(param.status === 'completed'){
                return (
                    <div className="showtix-search__transaction__buttons">
                        
                        <div className="showtix-dropdown">
                            <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.reprintEmail}</span>
                            <div className="showtix-dropdown__body">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.reprintPDF}    
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintPDF}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.props.printers.length === 0 || this.props.printers.length > 1 ? this.toggleAlertModal : this.printTransactionDymoTickets}
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.directDymo}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.dymoPDF}  
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintDymo}
                                </button>
                                <button
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.props.printersBoca.length === 0 || this.props.printersBoca.length >= 1 ? this.toggleAlertModalBoca : this.printTransactionBocaTickets}
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintBoca}
                                </button>
                                <button
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.props.printersStar.length === 0 || this.props.printersStar.length >= 1 ? this.toggleAlertModalStar : this.printTransactionStarTickets}
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintStar}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.reemail}    
                                    id={param.id}
                                >
                                    {strings.reemail}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.distribute}    
                                    id={param.id}
                                >
                                    {strings.distribute}
                                </button>
                            </div>    
                        </div>
                        {(!eventPayedOut && this.props.client.allow_callcenter_refund) &&
                            <React.Fragment>
                                {(param.tender_type === 'credit-card' || param.tender_type === 'reader') ? (
                                    <React.Fragment>
                                        <div className="showtix-dropdown">
                                            <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.releaseOptions}</span>
                                            <div className="showtix-dropdown__body">
                                                <button 
                                                    className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                                    onClick={this.props.toggleReleaseRefundModal}
                                                    id={param.id}
                                                    title={strings.releaseTitle}
                                                    description={strings.releaseDescription}
                                                    action="release-refund"
                                                    type="transaction"
                                                >
                                                    {strings.releaseRefund}
                                                </button>
                                                <button 
                                                    className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                                    onClick={this.props.toggleAlertModal}
                                                    id={param.id}
                                                    title={strings.releaseTitle}
                                                    description={strings.releaseDescription}
                                                    action="release"
                                                    type="transaction"
                                                >
                                                    {strings.releaseNoRefund}<br />
                                                    {strings.releaseNoRefund2}
                                                </button>
                                            </div>    
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <button 
                                        className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                        onClick={this.props.toggleAlertModal}
                                        id={param.id}
                                        title={strings.releaseTitle}
                                        description={strings.releaseDescription}
                                        action="release"
                                        type="transaction"
                                    >
                                        {strings.release}
                                    </button>
                                )}
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                    onClick={this.props.toggleAlertModal}
                                    id={param.id}
                                    title={strings.deleteTitle}
                                    description={strings.deleteDescription}
                                    action="delete"
                                    type="transaction"
                                >
                                    {strings.delete}
                                </button>
                            </React.Fragment>
                        }
                    </div>
                );
            }

            if(param.tender_type === 'reserved' || param.status === 'vipatron'){
                return (
                    <div className="showtix-search__transaction__buttons">
                        {!eventPayedOut &&
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                onClick={this.props.toggleAlertModal}
                                id={param.id}
                                title={strings.deleteTitle}
                                description={strings.deleteDescription}
                                action="delete"
                                type="transaction"
                            >
                                {strings.delete}
                            </button>
                        }
                    </div>
                );
            }

            if(param.status === 'error' || param.tender_type === 'cash'){
                return (
                    <div className="showtix-search__transaction__buttons">
                        <Link to="" className="showtix-button showtix-button__xsmall showtix-background__primary-3">
                            {strings.convert}
                        </Link>
                        {!eventPayedOut &&
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                onClick={this.props.toggleAlertModal}
                                id={param.id}
                                title={strings.deleteTitle}
                                description={strings.deleteDescription}
                                action="delete"
                                type="transaction"
                            >
                                {strings.delete}
                            </button>
                        }
                    </div>
                );
            }

            if(param.status === 'released'){
                return (
                    <div className="showtix-search__transaction__buttons">
                        {!eventPayedOut &&
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                onClick={this.props.toggleAlertModal}
                                id={param.id}
                                title={strings.deleteTitle}
                                description={strings.deleteDescription}
                                action="delete"
                                type="transaction"
                            >
                                {strings.delete}
                            </button>
                        }
                    </div>
                );
            }
        } else {
            if(param.status === 'completed'){
                return (
                    <div className="showtix-search__transaction__buttons">
                        <div className="showtix-dropdown">
                            <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.reprintEmail}</span>
                            <div className="showtix-dropdown__body">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.reprintPDF}    
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintPDF}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.props.printers.length === 0 || this.props.printers.length > 1 ? this.toggleAlertModal : this.printTransactionDymoTickets}
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.directDymo}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.dymoPDF}  
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintDymo}
                                </button>
                                <button
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.props.printersBoca.length === 0 || this.props.printersBoca.length >= 1 ? this.toggleAlertModalBoca : this.printTransactionBocaTickets}
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintBoca}
                                </button>
                                <button
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-2"
                                    onClick={this.props.printersStar.length === 0 || this.props.printersStar.length >= 1 ? this.toggleAlertModalStar : this.printTransactionStarTickets}
                                    id={param.id}
                                >
                                    <img src={printIcon} alt='' /> {strings.reprintStar}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-1"
                                    onClick={this.reemail}    
                                    id={param.id}
                                >
                                    {strings.reemail}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-1"
                                    onClick={this.distribute}    
                                    id={param.id}
                                >
                                    {strings.distribute}
                                </button>
                            </div>    
                        </div>
                        {this.renderRelease(param, eventPayedOut)}
                    </div>
                );
            }

            if(param.status === 'error'){
                return (
                    <div className="showtix-search__transaction__buttons">
                        {!eventPayedOut &&
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                onClick={this.props.toggleAlertModal}
                                id={param.id}
                                title={strings.deleteTitle}
                                description={strings.deleteDescription}
                                action="delete"
                                type="transaction"
                            >
                                {strings.delete}
                            </button>
                        }
                    </div>
                );
            } 

            if(param.tender_type === 'reserved' || param.status === 'vipatron') {
                return  (
                    <div className="showtix-search__transaction__buttons">
                        {!eventPayedOut &&
                            <button 
                                className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                onClick={this.props.toggleAlertModal}
                                id={param.id}
                                title={strings.deleteTitle}
                                description={strings.deleteDescription}
                                action="delete"
                                type="transaction"
                            >
                                {strings.delete}
                            </button>
                        }
                    </div>
                );
            }
        }
    }

    renderRelease = (param, eventPayedOut) => {
        if (this.props.user.role === 'box-office' && this.props.client.allow_callcenter_refund) {
            if (!eventPayedOut) {
                if (param.tender_type === 'credit-card' || param.tender_type === 'reader') {
                    return (
                        <div className="showtix-dropdown">
                            <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.releaseOptions}</span>
                            <div className="showtix-dropdown__body">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                    onClick={this.props.toggleReleaseRefundModal}
                                    id={param.id}
                                    title={strings.releaseTitle}
                                    description={strings.releaseDescription}
                                    action="release-refund"
                                    type="transaction"
                                >
                                    {strings.releaseRefund}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                    onClick={this.props.toggleAlertModal}
                                    id={param.id}
                                    title={strings.releaseTitle}
                                    description={strings.releaseDescription}
                                    action="release"
                                    type="transaction"
                                >
                                    {strings.releaseNoRefund}<br />
                                    {strings.releaseNoRefund2}
                                </button>
                            </div>    
                        </div>
                    );
                } else {
                    return (
                        <button 
                            className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                            onClick={this.props.toggleAlertModal}
                            id={param.id}
                            title={strings.releaseTitle}
                            description={strings.releaseDescription}
                            action="release"
                            type="transaction"
                        >
                            {strings.release}
                        </button>
                    );
                }
            } else {
                return null;
            }
        }
        if (this.props.user.role === 'client') {
            if (!eventPayedOut) {
                if (param.tender_type === 'credit-card' || param.tender_type === 'reader') {
                    return (
                        <div className="showtix-dropdown">
                            <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.releaseOptions}</span>
                            <div className="showtix-dropdown__body">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                    onClick={this.props.toggleReleaseRefundModal}
                                    id={param.id}
                                    title={strings.releaseTitle}
                                    description={strings.releaseDescription}
                                    action="release-refund"
                                    type="transaction"
                                >
                                    {strings.releaseRefund}
                                </button>
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                    onClick={this.props.toggleAlertModal}
                                    id={param.id}
                                    title={strings.releaseTitle}
                                    description={strings.releaseDescription}
                                    action="release"
                                    type="transaction"
                                >
                                    {strings.releaseNoRefund}<br />
                                    {strings.releaseNoRefund2}
                                </button>
                            </div>    
                        </div>
                    );
                } else {
                    return (
                        <button 
                            className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                            onClick={this.props.toggleAlertModal}
                            id={param.id}
                            title={strings.releaseTitle}
                            description={strings.releaseDescription}
                            action="release"
                            type="transaction"
                        >
                            {strings.release}
                        </button>
                    );
                }
            } else {
                return null;
            }
        }
    }

    render() {
        const dateString = moment.utc(this.props.transaction.creation_date).format('dddd MMMM Do, YYYY h:mm A');
        return (   
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.printerSelect()}
                    disabled={this.props.printers.length < 1}
                />
                <AlertModalBoca
                    isModalOpenBoca={this.state.isModalOpenBoca}
                    toggleAlertModalBoca={this.toggleAlertModalBoca}
                    confirmAlertModalBoca={this.confirmAlertModalBoca}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.printerSelectBoca()}
                    disabled={this.props.printersBoca.length < 1}
                />
                <AlertModalStar
                    isModalOpenStar={this.state.isModalOpenStar}
                    toggleAlertModalStar={this.toggleAlertModalStar}
                    confirmAlertModalStar={this.confirmAlertModalStar}
                    modalDescription={this.printerSelectStar()}
                    printersStar={this.props.printersStar}
                    printersStarUSB={this.props.printersStarUSB}
                />
                { this.props.transaction.visible &&
                    <div className="showtix-search__transaction">
                        <div className="showtix-search__transaction__header">
                            <div className="showtix-search__transaction__title">
                                {/*  !this.props.archived && 
                                    <div className="showtix-form__checkbox">
                                        <input
                                            type="checkbox"
                                            className="showtix-input"
                                            id={"input-" + this.props.transaction.id}
                                            value={this.props.transaction.id}
                                            onClick={this.props.updateSelectedIds}
                                        />
                                        <label className="showtix-label" htmlFor={"input-" + this.props.transaction.id}></label>
                                    </div>
                                */}
                                <div className="showtix-search__transaction__title__item">
                                    <span>Transaction ID:</span> #{this.props.transaction.id}
                                </div>
                                <div className="showtix-search__transaction__title__item">
                                    <span>Date:</span> {dateString} UTC 
                                </div>
                                <div className="showtix-search__transaction__title__item">
                                    <span>Tickets:</span> {this.props.transaction.tickets.length} {strings.tickets}
                                </div>
                                <div className="showtix-search__transaction__title__item">
                                    <span>Status:</span>
                                    { this.props.transaction.status === 'released' || this.props.transaction.status === 'refunded' ?
                                        <span className="showtix-badge showtix-background__primary-1">{this.props.transaction.status}</span>
                                    :
                                        (this.props.transaction.status)
                                    }
                                </div>
                                <div className="showtix-search__transaction__title__item">
                                    <span>Tender:</span>
                                    {typeof this.props.transaction.tender_type !== "undefined" && 
                                        [
                                            (this.props.transaction.tender_type).replace(/-/g, " ")
                                        ]
                                    }
                                </div>
                                <div className="showtix-search__transaction__title__item">
                                    <span>Mailing: </span>{this.transactionMail(this.props.transaction)}
                                </div>
                                <div className="showtix-search__transaction__title__item">
                                    <span>Price:</span>
                                    {new Intl.NumberFormat('en-US', { 
                                        style: 'currency', 
                                        currency: 'USD' 
                                    }).format(this.props.transaction.total)}
                                </div>
                                {this.props.transaction.donation > 0 && 
                                    <div className="showtix-search__transaction__flexpass">
                                        <h4 className="showtix-search__transaction__flexpass__title">{strings.donation}</h4>
                                        {new Intl.NumberFormat('en-US', { 
                                            style: 'currency', 
                                            currency: 'USD' 
                                        }).format(this.props.transaction.donation)}
                                    </div>
                                }
                            </div>    
                            
                            { !this.props.archived && 
                                this.transactionButtons(this.props.transaction)
                            }
                        </div> 
                        <Message 
                            message={this.state.message}
                        /> 
                        {this.props.transaction.flexpasses.length > 0 && 
                            this.transactionFlexpasses(this.props)
                        }
                        <div className="showtix-search__transaction__tickets">
                            <h3 className="showtix-search__transaction__tickets__title">TICKETS</h3>
                            {this.transactionTickets(this.props)}
                        </div>
                    </div>
                }
            </React.Fragment>    
        )
    }
}

SearchResultsTransaction.propTypes = {
    user: PropTypes.shape({
        role: PropTypes.string
    }),
    transaction: PropTypes.shape({
        creation_date: PropTypes.string,
        status: PropTypes.string,
        tender_type: PropTypes.string,
        id: PropTypes.number,
        total: PropTypes.number,
        tickets: PropTypes.array,
        ticketsFiltered: PropTypes.array
    }),
    archived: PropTypes.bool,
    toggleAlertModal: PropTypes.func,
    updateSelectedIds: PropTypes.func
}

export default SearchResultsTransaction;


// WEBPACK FOOTER //
// ./src/components/Search/SearchResults/SearchResultsTransaction/SearchResultsTransaction.js